import {
  AuthenticationService,
  AuthorizationService,
  SessionStore,
} from '@dirootie-domain/iam';
import { useContainer } from './use-container.hook';

export const useAuthorization = () => {
  const container = useContainer();
  const authorizationService = container.resolve<AuthorizationService>(
    'authorization-service'
  );
  return authorizationService;
};

export const useAuthentication = () => {
  const container = useContainer();
  const authenticationService = container.resolve<AuthenticationService>(
    'authentication-service'
  );
  return authenticationService;
};

export const useSessionStore = () => {
  const container = useContainer();
  const sessionStore = container.resolve<SessionStore>('session-store');
  return sessionStore;
};
